export default __webpack_public_path__ + "static/media/drawing-man1-focusfill.34795f1e.svg";